import type Owner from '@ember/owner';

import type { NoResultsBaseArgs } from 'webapp/components/no-results/base';
import NoResultsBaseComponent from 'webapp/components/no-results/base';

export default class NoResultsMergeDatasetsComponent extends NoResultsBaseComponent<NoResultsBaseArgs> {
	constructor(owner: Owner, args: NoResultsBaseArgs) {
		super(owner, args);

		this.titleText = 'Merge data from different sources';
		this.descText = 'Combine data from multiple datasets. Create 2+ datasets to get started.';
		this.readMoreUrl = 'https://help.databox.com/understanding-datasets';
		this.topImageLightUrl = '/images/placeholders/merge-datasets.svg';
		this.topImageDarkUrl = '/images/placeholders/merge-datasets.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-merge-datasets.svg';
		this.videoUrl = 'https://player.vimeo.com/video/1099367921';
		this.imageHeight = 328;

		this.trackingOrigin = 'merged_datasets';
	}

	override get createButtonText(): string {
		return 'Merge datasets';
	}
}
